/**
 * @generated SignedSource<<852bb2c09166c27cffa32665d68dcd1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type rosettaConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type rosettaConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type rosettaConfigAppConfigQuery = {
  response: rosettaConfigAppConfigQuery$data;
  variables: rosettaConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "rosetta"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "rosettaConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"rosetta\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "rosettaConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"rosetta\"})"
      }
    ]
  },
  "params": {
    "cacheID": "ba87f29d45e0c4f16483caf962f6a201",
    "id": null,
    "metadata": {},
    "name": "rosettaConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query rosettaConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"rosetta\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f94a6408d173e20bb7b38467308b96e";

export default node;
